<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div v-show="!modoEdicao">
        <div class="form-edit-page row row-space">
            <div class="form-item-char40">
                <TpDocGrupoSelect :ckAddTodos="true" :idSelecionado="grupoSelecionado.id" v-model:objSelecionado="grupoSelecionado" />
            </div>
            
            <div class="form-item">
                <label class="label-caption" for="nmPesquisa">Pesquisar</label>
                <input type="text" v-model="nmPesquisa" id="nmPesquisa" maxlength="50" v-uppercase />
            </div>

            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--add" @click="novoCadastro" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>


        <div v-if="lsDados.length>0" class="table-wrapper"><table>
            <thead><tr>
                <th>Código</th>
                <th>Tipo Documento</th>
                <th>Grupo</th>
                <th>Tipo Prazo</th>
                <th>Situação</th>
            </tr></thead>
            
            <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)" 
                :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                    <td class="col-width-char10 right">{{ formatInteger(obj.cdtpdoc) }}</td>
                    <td>{{ obj.nmtpdoc }}</td>
                    <td  class="col-width-char40">{{ obj.nmtpdocgrupo }}</td>
                    <td  class="col-width-char20">{{ obj.pztiponm }}</td>
                    <td  class="col-width-char10">{{ obj.nmativo }}</td>
            </tr></tbody>
        </table></div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-if="modoEdicao">
        <TpDocEditPage :idEdicao="idEdicao" @close="modoEdicao = false" @save="lerDados" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { genericPost } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import { formatInteger } from '@/funcoes/utils';
import TpDocEditPage from '../formularios/TpDocEditPage.vue';
import TpDocGrupoSelect from '@/components/selects/TpDocGrupoSelect.vue';

const emit = defineEmits(['close']);

const grupoSelecionado = ref({});
const msgAlerta = ref(null);
const nmPesquisa = ref(null);
const idEdicao = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


function closeForm() {emit('close');}


function editarCadastro(obj) {
    idEdicao.value = obj.id;
    modoEdicao.value = true;
}


const lerDados = async() => {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await genericPost('/listas/tpdocs', {
            idep: globalStore.idep,
            idreferencia: grupoSelecionado.value.id,
            nmpesquisar: nmPesquisa.value});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value= error;
    } finally {isLoading.value = false;}
}


const novoCadastro = () => {
    idEdicao.value = 0;
    modoEdicao.value = true;
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


onMounted(lerDados)
</script>